module.exports = __webpack_public_path__ + "img/close-icon.6097569c.svg";